
import { HttpCarrierServiceList ,HttpExportCarrierService} from '@/service/basicdata';
import TableList from "@components/templates/tablelist";
// import { mapGetters } from 'vuex';
import mixin from "./mixin";
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
        };
    },
    methods: {
        ajaxRequest: HttpCarrierServiceList,
        handleOperates(params, type) {
            switch (type) {
                case "export":
                    this.handleWebfs(
                        HttpExportCarrierService,
                        this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, active } = row;
            return [
                {
                    label: this.$t('global.common.query'),
                    to: {
                        name: "basicdataCarrierserviceUpdate",
                        params: {
                            type: 'query',
                        },
                        query: { id }
                    },
                    show: true
                },
                {
                    label: this.$t('global.common.edit'),
                    to: {
                        name: "basicdataCarrierserviceUpdate",
                        params: {
                            type: 'edit',
                        },
                        query: { id }
                    },
                    show:true
                },
            ];
        },
    },
    computed: {
        // ...mapGetters('dictionary', ['getOrgList', 'getProductList', 'getWarehouseList']),
        ToolsData() {
            return [
                {
                    label: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    theme: "primary",
                    to: {
                        name: "basicdataCarrierserviceUpdate",
                        params: {
                            type: 'add'
                        }
                    }
                },
                {
                    label: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    show: this.handleAuth('fbb.systemdelivercarrier.export')
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.basicdata.carrier_service_type', { defaultValue: '配送类型' }),
                    key: 'EQ_type',
                    tag: 'vSelect',
                    show: true,
                    options: this.getDeliveryTypes
                },
                {
                    label: this.$t('fbb.carrieraccount.carrieraccount', { defaultValue: '承运商' }),
                    key: 'EQ_carrierCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.carrieraccount.carrieraccount_service', { defaultValue: '承运商服务' }),
                    key: 'EQ_carrierServiceCode',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.basicdata.carrier_active', { defaultValue: '启用状态' }),
                    key: 'EQ_active',
                    tag: 'vSelect',
                    options: this.getActive,
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat', { defaultValue: '创建日期' }),
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: this.$t('fbb.basicdata.carrier_service_type', { defaultValue: '配送类型' }),
                    key: 'type',
                    render: (h, { row }) => this.findRenderLabel(this.getDeliveryTypes, row.type),
                },
                {
                    title: this.$t('fbb.carrieraccount.carrieraccount', { defaultValue: '承运商' }),
                    key: 'carrierCode',
                },
                {
                    title: this.$t('fbb.carrieraccount.carrieraccount_service', { defaultValue: '承运商服务代码' }),
                    key: 'carrierServiceCode',
                },
                {
                    title: this.$t('fbb.basicdata.carrier_service', { defaultValue: '承运商服务名称' }),
                    key: 'carrierServiceName',
                },
                {
                    title: this.$t('fbb.basicdata.carrier_active', { defaultValue: '启用状态' }),
                    key: 'active',
                    render: (h, { row }) => this.findRenderLabel(this.getActive, row.active),
                },
                {
                    title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'createdAt',
                }];
        },
    },
};




